import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from 'src/environments/environment';
import {CookieService} from 'ngx-cookie-service';
import {BaseApiService} from './base-api.service';

@Injectable()
export class AuthenticationService {

  static sessionKey = 'cid';

  constructor(private httpClient: HttpClient, private cookieService: CookieService) {
  }

  static LoginURL(): string {
    return environment.API_ENDPOINT + BaseApiService.API_PREFIX + '/system-user/login';
  }


  private getHeaders() {
    let headers = new HttpHeaders();
    headers = headers.append('Accept', 'application/json');
    headers = headers.append('Authorization', 'Bearer ' + this.cookieService.get(AuthenticationService.sessionKey));
    return {headers};
  }

  authenticate(admin: any) {
    const formData: any = new FormData();
    for (const key in admin) {
      if (Object.prototype.hasOwnProperty.call(admin, key)) {
        formData.append(key, admin[key]);
      }
    }
    return this.httpClient.post<any>(AuthenticationService.LoginURL(),
      admin);
  }


  isUserLogged() {
    // return true;

    if (this.cookieService.get(AuthenticationService.sessionKey)) {
      return true;
    }
    return false;
  }
}
